// Hook quản lý trạng thái đăng nhập
import { useState, useEffect, createContext, useContext } from 'react'
import { api } from '../api'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('tchat_token')
    if (!token) { setLoading(false); return }

    api.me()
      .then(({ user }) => setUser(user))
      .catch(() => localStorage.removeItem('tchat_token'))
      .finally(() => setLoading(false))
  }, [])

  async function login(loginId, password, deviceToken, deviceName) {
    const result = await api.login({ login: loginId, password, device_token: deviceToken, device_name: deviceName })
    if (result.needs_otp) return result  // caller xử lý màn hình OTP
    localStorage.setItem('tchat_token', result.token)
    setUser(result.user)
    return result
  }

  async function verifyOtp(loginId, password, deviceToken, deviceName, otpCode) {
    const { user, token } = await api.verifyOtp({
      login: loginId, password, device_token: deviceToken, device_name: deviceName, otp_code: otpCode,
    })
    localStorage.setItem('tchat_token', token)
    setUser(user)
  }

  async function register(username, password) {
    const result = await api.register({ username, password })
    return result
  }

  function logout() {
    localStorage.removeItem('tchat_token')
    setUser(null)
  }

  function updateUser(patch) {
    setUser(prev => ({ ...prev, ...patch }))
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateUser, verifyOtp }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}
